export default "__VITE_ASSET__DlcuccWp__"